const STYLE_MARKER = "data-formbrew-embed-styles";

export const installFormbrewStyles = (script: HTMLScriptElement): void => {
  if (script.dataset.formbrewStyles === "false") {
    return;
  }

  const stylesheetUrl = resolveStylesheetUrl(script);
  const installedStyles = document.querySelectorAll<HTMLLinkElement>(`link[${STYLE_MARKER}]`);

  for (const installedStyle of installedStyles) {
    if (installedStyle.href === stylesheetUrl) {
      return;
    }
  }

  const link = document.createElement("link");
  link.href = stylesheetUrl;
  link.rel = "stylesheet";
  link.setAttribute(STYLE_MARKER, "");

  if (script.nonce) {
    link.nonce = script.nonce;
  }

  document.head.append(link);
};

const resolveStylesheetUrl = (script: HTMLScriptElement): string => {
  const configuredUrl = script.dataset.formbrewStylesUrl?.trim();

  if (configuredUrl) {
    return new URL(configuredUrl, document.baseURI).href;
  }

  const scriptUrl = new URL(script.src);

  if (!scriptUrl.pathname.endsWith(".js")) {
    scriptUrl.pathname = `${scriptUrl.pathname.replace(/\/$/, "")}/dist/styles.css`;
    scriptUrl.search = "";
    scriptUrl.hash = "";

    return scriptUrl.href;
  }

  return new URL("./styles.css", scriptUrl).href;
};
